import React from 'react';
import { Skeleton } from 'fronton-react';
import { contentBlock, skeletonIcon, skeletonRow } from './styles';

const SKELETON_ROWS = Array.from({ length: 3 }, (_, i) => `skeleton-row-${i}`);

export const LOADING_STATE_DATA_QA = 'certificate-loading-state';

export const LoadingState = () => (
  <>
    {SKELETON_ROWS.map((id) => (
      <div key={id} data-qa={LOADING_STATE_DATA_QA} className={skeletonRow}>
        <Skeleton className={skeletonIcon} showLoading={true} variant="control" width="40px" height="40px" />
        <div className={contentBlock}>
          <Skeleton showLoading={true} variant="s" size="body_short" width="100%" />
          <Skeleton showLoading={true} variant="minor" size="caption" width="70%" />
        </div>
      </div>
    ))}
  </>
);
